import api from "../api";
import { toast } from 'vue3-toastify'

export default {
  namespaced: true,
  state: {
    boxStore: {},
    blockDate: {}
    //boxes: []
  },

  getters: {
  },

  actions: {
    
    async get_box_by_store({ commit }, store_id) {
      try {
        api.get(`/v1/box-store/${store_id}`)
        .then((res) => {
            commit("GET_BOX_STORE", res.data);
        })
        .catch((error) => {
            commit("ERROR_BOX_STORE", error);
        })
        .finally(() => (
            // this.loading = false
            console.log('login request end')
        ));
      } catch (e) {
        commit("ERROR_BOX_STORE", e);
      }
    },

    async save_box({ commit }, payload = []) {
      try {
        api.post(`/v1/box-store`, payload)
          .then((res) => {
            commit("GET_BOX_STORE", res.data);
            toast.success("Criado com sucesso!", {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
            });
          })
          .catch((error) => {
            commit("ERROR_BOX_STORE", error);
            toast.warning(error.response.data.message, {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
            });
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_BOX_STORE", e);
      }
    },

    async delete_box({ commit }, box_id) {
      try {
        api.delete(`/v1/box-store/${box_id}`)
          .then((res) => {
            if(res?.data?.success == false){
              commit("ERROR_BOX_STORE", res?.data);
              toast.warning(res.data.message, {
                  type: 'default',
                  theme: 'colored',
                  hideProgressBar: true,
                  dangerouslyHTMLString: true
              });
              
            }else{
              commit("GET_BOX_STORE", res.data);
              toast.success("Deletado com sucesso!", {
                  type: 'default',
                  theme: 'colored',
                  hideProgressBar: true,
                  dangerouslyHTMLString: true
              });
            }  
          })
          .catch((error) => {
            console.log(error)
            commit("ERROR_BOX_STORE", error);
            toast.warning("Erro desconhecido, contate o suporte ou tente novamente mais tarde", {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
            });
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_BOX_STORE", e);
      }
    },

    async get_block_date({ commit }) {
      try {
        api.get(`/v1/block-date`)
        .then((res) => {
            commit("GET_BLOCK_DATE", res.data);
        })
        .catch((error) => {
            commit("ERROR_BLOCK_DATE", error);
        })
        .finally(() => (
            // this.loading = false
            console.log('login request end')
        ));
      } catch (e) {
        commit("ERROR_BLOCK_DATE", e);
      }
    },

  },
  mutations: {

    GET_BOX_STORE(state, data) {
      state.boxStore = data;
    },
    ERROR_BOX_STORE(state, data) {
      console.log(data);
    },

    GET_BLOCK_DATE(state, data) {
      state.blockDate = data;
    },
    ERROR_BOX_STORE(state, data) {
      console.log(data);
    },
  }
}